(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ap-aromatica-collection"] && !Shopify.designMode) return;
  try {
    
  class AromaticaHouseCollection {
    constructor(root) {
      this.root = root;
      this.endpoint = root.dataset.endpoint;
      this.pageSize = Number(root.dataset.pageSize) || 24;
      this.products = [];
      this.filteredProducts = [];
      this.activeFamily = '';
      this.activeFilters = {
        gender: new Set(),
        price: new Set(),
        occasion: new Set(),
        season: new Set()
      };
      this.searchTerm = '';
      this.sortMode = 'featured';
      this.visibleCount = this.pageSize;
      this.toolbar = root.querySelector('.ap-house-collection__toolbar');
      this.grid = root.querySelector('[data-ap-house-grid]');
      this.familyContainer = root.querySelector('[data-ap-house-families]');
      this.genderContainer = root.querySelector('[data-ap-house-genders]');
      this.priceContainer = root.querySelector('[data-ap-house-prices]');
      this.occasionContainer = root.querySelector('[data-ap-house-occasions]');
      this.seasonContainer = root.querySelector('[data-ap-house-seasons]');
      this.activeFiltersContainer = root.querySelector('[data-ap-house-active-filters]');
      this.count = root.querySelector('[data-ap-house-count]');
      this.search = root.querySelector('[data-ap-house-search]');
      this.sort = root.querySelector('[data-ap-house-sort]');
      this.clear = root.querySelector('[data-ap-house-clear]');
      this.empty = root.querySelector('[data-ap-house-empty]');
      this.reset = root.querySelector('[data-ap-house-reset]');
      this.moreWrap = root.querySelector('[data-ap-house-more-wrap]');
      this.more = root.querySelector('[data-ap-house-more]');
      this.filterPanel = root.querySelector('[data-ap-house-filter-panel]');
      this.filterOpen = root.querySelector('[data-ap-house-filter-open]');
      this.filterClose = root.querySelector('[data-ap-house-filter-close]');
      this.filterApply = root.querySelector('[data-ap-house-filter-apply]');
      this.filterBackdrop = root.querySelector('[data-ap-house-filter-backdrop]');
      this.mobileReset = root.querySelector('[data-ap-house-mobile-reset]');
      this.filterCount = root.querySelector('[data-ap-house-filter-count]');
      this.filterPanelCount = root.querySelector('[data-ap-house-filter-panel-count]');
      this.filterResultCount = root.querySelector('[data-ap-house-filter-result-count]');
      this.mobileFilterMedia = window.matchMedia('(max-width: 47.999rem)');
      this.labels = root.dataset;
      this.vocabulary = JSON.parse(root.querySelector('[data-ap-discovery-labels]').textContent);
      this.restoreUrlState();
      this.bindEvents();
      this.setupStickyToolbar();
      this.load();
    }

    restoreUrlState() {
      const params = new URLSearchParams(window.location.search);
      this.activeFamily = params.get('ap_family') || '';
      Object.keys(this.activeFilters).forEach((group) => {
        params.getAll(`ap_${group}`).filter(Boolean).forEach((value) => {
          this.activeFilters[group].add(value);
        });
      });

      const query = params.get('ap_q') || '';
      this.search.value = query;
      this.searchTerm = query.trim().toLowerCase();

      const sort = params.get('ap_sort') || 'featured';
      const validSorts = ['featured', 'name-asc', 'price-asc', 'price-desc'];
      this.sortMode = validSorts.includes(sort) ? sort : 'featured';
      this.sort.value = this.sortMode;
    }

    updateUrlState() {
      if (!window.history?.replaceState) return;
      const url = new URL(window.location.href);
      const setOrDelete = (key, value) => {
        if (value) {
          url.searchParams.set(key, value);
        } else {
          url.searchParams.delete(key);
        }
      };

      setOrDelete('ap_family', this.activeFamily);
      setOrDelete('ap_q', this.search.value.trim());
      setOrDelete('ap_sort', this.sortMode === 'featured' ? '' : this.sortMode);
      Object.entries(this.activeFilters).forEach(([group, values]) => {
        url.searchParams.delete(`ap_${group}`);
        values.forEach((value) => url.searchParams.append(`ap_${group}`, value));
      });
      window.history.replaceState({}, '', `${url.pathname}${url.search}${url.hash}`);
    }

    setupStickyToolbar() {
      let frame = 0;
      const update = () => {
        frame = 0;
        if (!this.mobileFilterMedia.matches) {
          this.root.style.removeProperty('--ap-house-sticky-top');
          return;
        }
        const header = document.querySelector('.section-header');
        const headerBottom = header ? Math.max(0, Math.ceil(header.getBoundingClientRect().bottom)) : 0;
        this.root.style.setProperty('--ap-house-sticky-top', `${headerBottom}px`);
      };
      const requestUpdate = () => {
        if (frame) return;
        frame = window.requestAnimationFrame(update);
      };
      window.addEventListener('scroll', requestUpdate, { passive: true });
      window.addEventListener('resize', requestUpdate, { passive: true });
      document.addEventListener('eurus:sticky-header-moved', requestUpdate);
      this.mobileFilterMedia.addEventListener('change', requestUpdate);
      requestUpdate();
    }

    bindEvents() {
      this.search.addEventListener('input', (event) => {
        this.searchTerm = event.target.value.trim().toLowerCase();
        this.visibleCount = this.pageSize;
        this.applyFilters();
      });

      this.sort.addEventListener('change', (event) => {
        this.sortMode = event.target.value;
        this.visibleCount = this.pageSize;
        this.applyFilters();
      });

      this.clear.addEventListener('click', () => this.resetFilters());
      this.reset.addEventListener('click', () => this.resetFilters());
      this.mobileReset.addEventListener('click', () => this.resetFilters());
      this.filterOpen.addEventListener('click', () => this.openMobileFilters());
      this.filterClose.addEventListener('click', () => this.closeMobileFilters());
      this.filterApply.addEventListener('click', () => this.closeMobileFilters());
      this.filterBackdrop.addEventListener('click', () => this.closeMobileFilters());
      this.mobileFilterMedia.addEventListener('change', (event) => {
        if (!event.matches) this.closeMobileFilters(false);
      });
      this.filterPanel.addEventListener('keydown', (event) => this.handleFilterPanelKeys(event));
      this.more.addEventListener('click', () => {
        this.visibleCount += this.pageSize;
        this.renderProducts();
      });

      this.root.addEventListener('click', (event) => {
        const option = event.target.closest('[data-filter-group][data-filter-value]');
        if (option) {
          const group = option.dataset.filterGroup;
          const value = option.dataset.filterValue;
          if (!this.activeFilters[group]) return;
          if (this.activeFilters[group].has(value)) {
            this.activeFilters[group].delete(value);
          } else {
            if (group === 'price') this.activeFilters[group].clear();
            this.activeFilters[group].add(value);
          }
          this.syncFilterButtons();
          this.visibleCount = this.pageSize;
          this.applyFilters();
          return;
        }

        const remove = event.target.closest('[data-remove-filter-group][data-remove-filter-value]');
        if (!remove) return;
        const group = remove.dataset.removeFilterGroup;
        const value = remove.dataset.removeFilterValue;
        if (group === 'family') this.activeFamily = '';
        if (this.activeFilters[group]) this.activeFilters[group].delete(value);
        this.syncFilterButtons();
        this.visibleCount = this.pageSize;
        this.applyFilters();
      });

      this.root.querySelectorAll('[data-ap-house-facet]').forEach((facet) => {
        facet.addEventListener('toggle', () => {
          if (!facet.open) return;
          this.root.querySelectorAll('[data-ap-house-facet]').forEach((other) => {
            if (other !== facet) other.open = false;
          });
        });
      });
    }

    openMobileFilters() {
      if (!this.mobileFilterMedia.matches) return;
      this.filterPanel.classList.add('is-open');
      this.filterPanel.setAttribute('role', 'dialog');
      this.filterPanel.setAttribute('aria-modal', 'true');
      this.filterPanel.setAttribute('aria-label', this.filterOpen.querySelector('span').textContent.trim());
      this.filterOpen.setAttribute('aria-expanded', 'true');
      this.filterBackdrop.hidden = false;
      document.body.classList.add('ap-house-filter-open');
      this.filterPanel.focus();
    }

    closeMobileFilters(restoreFocus = true) {
      const wasOpen = this.filterPanel.classList.contains('is-open');
      this.filterPanel.classList.remove('is-open');
      this.filterPanel.removeAttribute('role');
      this.filterPanel.removeAttribute('aria-modal');
      this.filterPanel.removeAttribute('aria-label');
      this.filterOpen.setAttribute('aria-expanded', 'false');
      this.filterBackdrop.hidden = true;
      document.body.classList.remove('ap-house-filter-open');
      if (wasOpen && restoreFocus) this.filterOpen.focus();
    }

    handleFilterPanelKeys(event) {
      if (!this.filterPanel.classList.contains('is-open')) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        this.closeMobileFilters();
        return;
      }
      if (event.key !== 'Tab') return;
      const focusable = [...this.filterPanel.querySelectorAll('button:not([hidden]), input:not([hidden]), select:not([hidden]), summary')]
        .filter((element) => !element.disabled && element.offsetParent !== null);
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    async load() {
      try {
        const firstPage = await this.fetchPage(1);
        const remainingPages = [];
        for (let page = 2; page <= firstPage.pages; page += 1) {
          remainingPages.push(this.fetchPage(page));
        }
        const remainingData = await Promise.all(remainingPages);
        this.products = [firstPage, ...remainingData]
          .flatMap((page) => page.products || [])
          .filter((product, index, products) => products.findIndex((item) => item.id === product.id) === index);
        this.renderFamilies();
        this.renderFacets();
        this.syncFilterButtons();
        this.applyFilters();
      } catch (error) {
        this.grid.setAttribute('aria-busy', 'false');
        this.grid.innerHTML = '';
        this.empty.hidden = false;
        this.empty.querySelector('p').textContent = this.labels.loadError;
      }
    }

    async fetchPage(page) {
      const separator = this.endpoint.includes('?') ? '&' : '?';
      const response = await fetch(`${this.endpoint}${separator}page=${page}`);
      if (!response.ok) throw new Error(`Collection data request failed: ${response.status}`);
      return response.json();
    }

    renderFamilies() {
      const families = [...new Set(this.products.map((product) => product.family).filter(Boolean))]
        .sort((a, b) => a.localeCompare(b));
      const values = ['', ...families];
      this.familyContainer.innerHTML = values.map((family) => {
        const label = this.vocabulary[family] || family || this.labels.allLabel;
        const count = family
          ? this.products.filter((product) => product.family === family).length
          : this.products.length;
        return `<button class="ap-house-collection__chip" type="button" data-family="${this.escape(family)}" aria-pressed="${family === this.activeFamily}">${this.escape(label)} <span>${count}</span></button>`;
      }).join('');

      this.familyContainer.addEventListener('click', (event) => {
        const button = event.target.closest('[data-family]');
        if (!button) return;
        this.activeFamily = button.dataset.family;
        this.visibleCount = this.pageSize;
        this.familyContainer.querySelectorAll('[data-family]').forEach((chip) => {
          chip.setAttribute('aria-pressed', String(chip === button));
        });
        this.applyFilters();
      });
    }

    renderFacets() {
      this.renderFacet(
        this.genderContainer,
        'gender',
        this.uniqueValues('gender', (value) => this.normalizeGender(value)),
        (product) => this.asArray(product.gender).map((value) => this.normalizeGender(value)).filter(Boolean)
      );
      this.renderFacet(this.occasionContainer, 'occasion', this.uniqueValues('occasions'), (product) => this.asArray(product.occasions));
      this.renderFacet(this.seasonContainer, 'season', this.uniqueValues('seasons'), (product) => this.asArray(product.seasons));

      this.priceRanges = [
        { value: 'under-60', label: this.labels.priceUnder, matches: (product) => product.price < 6000 },
        { value: '60-74', label: this.labels.priceMid, matches: (product) => product.price >= 6000 && product.price < 7500 },
        { value: '75-plus', label: this.labels.pricePremium, matches: (product) => product.price >= 7500 }
      ];
      this.priceContainer.innerHTML = this.priceRanges.map((range) => {
        const count = this.products.filter(range.matches).length;
        return this.optionMarkup('price', range.value, range.label, count);
      }).join('');
    }

    renderFacet(container, group, values, getter) {
      const facet = container.closest('[data-ap-house-facet]');
      facet.hidden = values.length === 0;
      container.innerHTML = values.map((value) => {
        const count = this.products.filter((product) => {
          const productValue = getter(product);
          return Array.isArray(productValue) ? productValue.includes(value) : productValue === value;
        }).length;
        return this.optionMarkup(group, value, this.vocabulary[value] || value, count);
      }).join('');
    }

    optionMarkup(group, value, label, count) {
      return `<button class="ap-house-collection__facet-option" type="button" data-filter-group="${this.escape(group)}" data-filter-value="${this.escape(value)}" aria-pressed="false">${this.escape(label)} <span>${count}</span></button>`;
    }

    uniqueValues(field, normalizer = (value) => value) {
      return [...new Set(this.products.flatMap((product) => this.asArray(product[field]).map(normalizer)).filter(Boolean))]
        .sort((a, b) => a.localeCompare(b));
    }

    asArray(value) {
      if (Array.isArray(value)) return value.filter(Boolean);
      return value ? [value] : [];
    }

    normalizeGender(value) {
      const normalized = String(value || '').trim().toLowerCase();
      if (['female', 'famle', 'feminine', 'woman', 'women'].includes(normalized)) return 'Women';
      if (['male', 'male1', 'male-1', 'masculine', 'man', 'men'].includes(normalized)) return 'Men';
      if (['unisex', 'unsex'].includes(normalized)) return 'Unisex';
      return value || '';
    }

    applyFilters() {
      this.filteredProducts = this.products.filter((product) => {
        const matchesFamily = !this.activeFamily || product.family === this.activeFamily;
        const genders = this.asArray(product.gender).map((value) => this.normalizeGender(value)).filter(Boolean);
        const occasions = this.asArray(product.occasions);
        const seasons = this.asArray(product.seasons);
        const matchesGender = this.activeFilters.gender.size === 0 || genders.some((value) => this.activeFilters.gender.has(value));
        const matchesPrice = this.activeFilters.price.size === 0 || this.priceRanges.some((range) => this.activeFilters.price.has(range.value) && range.matches(product));
        const matchesOccasion = this.activeFilters.occasion.size === 0 || occasions.some((value) => this.activeFilters.occasion.has(value));
        const matchesSeason = this.activeFilters.season.size === 0 || seasons.some((value) => this.activeFilters.season.has(value));
        const searchable = [product.title, product.fullTitle, product.family, ...genders, ...occasions, ...seasons, ...(product.notes || [])]
          .filter(Boolean)
          .join(' ')
          .toLowerCase();
        return matchesFamily && matchesGender && matchesPrice && matchesOccasion && matchesSeason && (!this.searchTerm || searchable.includes(this.searchTerm));
      });

      const sorters = {
        'name-asc': (a, b) => a.title.localeCompare(b.title),
        'price-asc': (a, b) => a.price - b.price,
        'price-desc': (a, b) => b.price - a.price,
        featured: (a, b) => Number(b.available) - Number(a.available) || a.title.localeCompare(b.title)
      };
      this.filteredProducts.sort(sorters[this.sortMode] || sorters.featured);
      const hasFacetFilters = Object.values(this.activeFilters).some((values) => values.size > 0);
      this.clear.hidden = !this.activeFamily && !this.searchTerm && !hasFacetFilters;
      this.renderActiveFilters();
      this.renderProducts();
      this.updateUrlState();
    }

    syncFilterButtons() {
      this.familyContainer.querySelectorAll('[data-family]').forEach((chip) => {
        chip.setAttribute('aria-pressed', String(chip.dataset.family === this.activeFamily));
      });
      this.root.querySelectorAll('[data-filter-group][data-filter-value]').forEach((option) => {
        const values = this.activeFilters[option.dataset.filterGroup];
        option.setAttribute('aria-pressed', String(Boolean(values && values.has(option.dataset.filterValue))));
      });
      Object.entries(this.activeFilters).forEach(([group, values]) => {
        const count = this.root.querySelector(`[data-ap-house-active-count="${group}"]`);
        if (!count) return;
        count.hidden = values.size === 0;
        count.textContent = values.size;
      });
      const activeCount = Number(Boolean(this.activeFamily))
        + Object.values(this.activeFilters).reduce((total, values) => total + values.size, 0);
      this.filterCount.hidden = activeCount === 0;
      this.filterCount.textContent = activeCount;
      this.filterPanelCount.textContent = activeCount ? `(${activeCount})` : '';
    }

    renderActiveFilters() {
      const filters = [];
      if (this.activeFamily) filters.push({ group: 'family', value: this.activeFamily, label: this.activeFamily });
      Object.entries(this.activeFilters).forEach(([group, values]) => {
        values.forEach((value) => {
          const priceRange = group === 'price' ? this.priceRanges.find((range) => range.value === value) : null;
          filters.push({ group, value, label: priceRange ? priceRange.label : value });
        });
      });
      this.activeFiltersContainer.hidden = filters.length === 0;
      this.activeFiltersContainer.innerHTML = filters.map((filter) => `<button class="ap-house-collection__active-filter" type="button" data-remove-filter-group="${this.escape(filter.group)}" data-remove-filter-value="${this.escape(filter.value)}">${this.escape(this.vocabulary[filter.label] || filter.label)} ×</button>`).join('');
    }

    renderProducts() {
      const visibleProducts = this.filteredProducts.slice(0, this.visibleCount);
      this.grid.setAttribute('aria-busy', 'false');
      this.grid.innerHTML = visibleProducts.map((product) => this.card(product)).join('');
      this.count.textContent = `${this.filteredProducts.length} ${this.labels.productsLabel}`;
      this.filterResultCount.textContent = `(${this.filteredProducts.length})`;
      this.empty.hidden = this.filteredProducts.length !== 0;
      this.moreWrap.hidden = this.visibleCount >= this.filteredProducts.length;
    }

    resetFilters() {
      this.activeFamily = '';
      Object.values(this.activeFilters).forEach((values) => values.clear());
      this.searchTerm = '';
      this.search.value = '';
      this.visibleCount = this.pageSize;
      this.syncFilterButtons();
      this.applyFilters();
    }

    card(product) {
      const family = product.family || this.labels.profilePending;
      const notes = Array.isArray(product.notes) ? product.notes.slice(0, 3).join(' · ') : '';
      const image = product.image
        ? `<img src="${this.escape(product.image)}" alt="${this.escape(product.imageAlt || product.fullTitle)}" loading="lazy" width="1000" height="1000">`
        : '';
      const comparePrice = product.compareAtPrice > product.price
        ? `<s>${this.escape(product.compareAtPriceLabel)}</s>`
        : '';
      const status = product.available ? '' : `<span class="ap-house-card__status">${this.escape(this.labels.soldOutLabel)}</span>`;
      const pricePrefix = product.priceVaries ? `${this.escape(this.labels.fromLabel)} ` : '';
      const actionLabel = product.available
        ? (product.hasOnlyDefaultVariant ? this.labels.shopNowLabel : this.labels.chooseOptionsLabel)
        : this.labels.viewLabel;
      return `<article class="ap-house-card">
        <a class="ap-house-card__media" href="${this.escape(product.url)}" aria-label="${this.escape(product.fullTitle)}">
          ${image}${status}
        </a>
        <div class="ap-house-card__content">
          <p class="ap-house-card__family">${this.escape(this.vocabulary[family] || family)}</p>
          <h2><a href="${this.escape(product.url)}">${this.escape(product.title)}</a></h2>
          <p class="ap-house-card__notes">${this.escape(notes)}</p>
          <div class="ap-house-card__bottom">
            <div class="ap-house-card__price">${comparePrice}<span>${pricePrefix}${this.escape(product.priceLabel)}</span></div>
            <a class="ap-house-card__view" href="${this.escape(product.url)}">${this.escape(actionLabel)}</a>
          </div>
        </div>
      </article>`;
    }

    escape(value) {
      const element = document.createElement('div');
      element.textContent = String(value ?? '');
      return element.innerHTML;
    }
  }

  document.querySelectorAll('[data-ap-house-collection]').forEach((root) => {
    if (!root.apHouseCollection) root.apHouseCollection = new AromaticaHouseCollection(root);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ap-product-recommendations"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-ap-rec-form]');
    if (!form) return;
    event.preventDefault();
    const button = form.querySelector('button[type="submit"]');
    if (button.disabled) return;
    const error = form.querySelector('[data-ap-rec-error]');
    error.hidden = true;
    button.disabled = true;
    form.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch(`${form.action}.js`, {
        method: 'POST',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(new FormData(form).get('id')), quantity: 1 }] })
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || error.textContent);
      window.location.assign(form.dataset.cartUrl);
    } catch (failure) {
      error.hidden = false;
      button.disabled = false;
      form.removeAttribute('aria-busy');
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ap-product-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ap-review-labels')) {
    customElements.define('ap-review-labels', class extends HTMLElement {
      connectedCallback() {
        const translateSortLabel = () => {
          const text = this.dataset.sortLabel;
          if (!text) return;
          this.querySelectorAll('.jdgm-sort-dropdown-label').forEach((label) => {
            if (label.textContent.trim() === 'Sort by' && label.textContent !== text) {
              label.textContent = text;
            }
          });
        };
        this.observer = new MutationObserver(translateSortLabel);
        this.observer.observe(this, { childList: true, subtree: true, characterData: true });
        translateSortLabel();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ap-scent-finder"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const normalize = (value) => String(value || '').trim().toLowerCase();

    const escapeHtml = (value) => String(value || '')
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#039;');

    class AromaticaScentFinder {
      constructor(root) {
        if (root.dataset.apFinderReady === 'true') return;
        root.dataset.apFinderReady = 'true';
        this.root = root;
        this.quiz = root.querySelector('[data-ap-finder-quiz]');
        this.results = root.querySelector('[data-ap-finder-results]');
        this.steps = [...root.querySelectorAll('[data-ap-finder-step]')];
        this.nextButton = root.querySelector('[data-ap-finder-next]');
        this.nextLabel = root.querySelector('[data-ap-finder-next-label]');
        this.backButton = root.querySelector('[data-ap-finder-back]');
        this.restartButton = root.querySelector('[data-ap-finder-restart]');
        this.progressLabel = root.querySelector('[data-ap-finder-progress-label]');
        this.progressValue = root.querySelector('[data-ap-finder-progress-value]');
        this.resultGrid = root.querySelector('[data-ap-finder-result-grid]');
        this.status = root.querySelector('[data-ap-finder-status]');
        this.count = root.querySelector('[data-ap-finder-count]');
        this.currentStep = 0;
        this.answers = {};
        this.products = [];
        this.loadError = null;
        this.loadingPromise = this.loadProducts().catch((error) => {
          this.loadError = error;
          return [];
        });
        this.bind();
        this.updateNavigation();
      }

      bind() {
        this.quiz.addEventListener('change', (event) => {
          const input = event.target.closest('input[type="radio"]');
          if (!input) return;
          const step = input.closest('[data-ap-finder-step]');
          const question = step.dataset.question;
          this.answers[question] = {
            label: input.closest('label').querySelector('span').textContent.trim(),
            values: (input.dataset.matchValues || input.value).split('|')
          };
          this.updateNavigation();
        });

        this.nextButton.addEventListener('click', () => {
          if (!this.answers[this.steps[this.currentStep].dataset.question]) return;
          if (this.currentStep === this.steps.length - 1) {
            this.showResults();
            return;
          }
          this.showStep(this.currentStep + 1);
        });

        this.backButton.addEventListener('click', () => {
          if (this.currentStep > 0) this.showStep(this.currentStep - 1);
        });

        this.restartButton.addEventListener('click', () => this.restart());
      }

      showStep(index) {
        this.steps[this.currentStep].hidden = true;
        this.currentStep = index;
        const step = this.steps[this.currentStep];
        step.hidden = false;
        step.classList.remove('is-entering');
        window.requestAnimationFrame(() => step.classList.add('is-entering'));
        this.updateNavigation();
        const focusTarget = step.querySelector('input:checked') || step.querySelector('input');
        focusTarget?.focus({ preventScroll: true });
      }

      updateNavigation() {
        const question = this.steps[this.currentStep].dataset.question;
        this.nextButton.disabled = !this.answers[question];
        this.backButton.hidden = this.currentStep === 0;
        this.progressLabel.textContent = `${this.root.dataset.stepLabel} ${this.currentStep + 1} / ${this.steps.length}`;
        this.progressValue.style.inlineSize = `${((this.currentStep + 1) / this.steps.length) * 100}%`;
        this.nextLabel.textContent = this.currentStep === this.steps.length - 1
          ? this.root.dataset.finalLabel
          : this.root.dataset.nextLabel;
      }

      async loadPage(page) {
        const url = new URL(this.root.dataset.sourceUrl, window.location.origin);
        const currentUrl = new URL(window.location.href);
        if (currentUrl.searchParams.has('preview_theme_id')) {
          url.searchParams.set('preview_theme_id', currentUrl.searchParams.get('preview_theme_id'));
        }
        url.searchParams.set('page', page);
        const controller = new AbortController();
        const timeout = window.setTimeout(() => controller.abort(), 15000);

        try {
          const response = await fetch(url.toString(), {
            cache: 'no-store',
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
            signal: controller.signal
          });
          if (!response.ok) throw new Error(`Scent data request failed: ${response.status}`);
          return response.json();
        } finally {
          window.clearTimeout(timeout);
        }
      }

      async loadProducts() {
        try {
          const firstPage = await this.loadPage(1);
          const products = [...(firstPage.products || [])];
          const pageCount = Number(firstPage.pages || 1);
          if (pageCount > 1) {
            const pageNumbers = Array.from({ length: pageCount - 1 }, (_, index) => index + 2);
            const nextPages = await Promise.all(pageNumbers.map((page) => this.loadPage(page)));
            nextPages.forEach((page) => products.push(...(page.products || [])));
          }
          const previewMode = this.root.dataset.previewMode === 'true';
          this.products = products.filter((product) => product.available && (previewMode || product.enabled === true));
          this.count.textContent = `${this.products.length} ${this.root.dataset.readyLabel}`;
          return this.products;
        } catch (error) {
          this.count.textContent = '';
          throw error;
        }
      }

      includes(values, answer) {
        const normalized = (values || []).map(normalize);
        return answer.values.some((value) => normalized.includes(normalize(value)));
      }

      score(product) {
        let score = 0;
        const matches = [];
        const familyAnswer = this.answers.family;

        if (familyAnswer.values.some((value) => normalize(value) === normalize(product.family))) {
          score += 35;
          matches.push(familyAnswer.label);
        } else if (this.includes(product.accents, familyAnswer)) {
          score += 25;
          matches.push(familyAnswer.label);
        }

        if (this.includes(product.moods, this.answers.mood)) {
          score += 30;
          matches.push(this.answers.mood.label);
        }

        if (this.includes(product.occasions, this.answers.occasion)) {
          score += 20;
          matches.push(this.answers.occasion.label);
        }

        const seasonMatch = this.includes(product.seasons, this.answers.season);
        const allSeason = (product.seasons || []).map(normalize).includes('all season');
        if (seasonMatch || allSeason) {
          score += 15;
          matches.push(this.answers.season.label);
        }

        return {
          product,
          score,
          matches,
          priority: Number(product.priority || 0)
        };
      }

      async showResults() {
        this.quiz.hidden = true;
        this.results.hidden = false;
        this.resultGrid.innerHTML = '';
        this.status.textContent = this.root.dataset.loadingText;

        try {
          await this.loadingPromise;
          if (this.loadError) throw this.loadError;
          if (!this.products.length) {
            this.status.innerHTML = `<strong>${escapeHtml(this.root.dataset.emptyTitle)}</strong><p>${escapeHtml(this.root.dataset.emptyText)}</p>`;
            return;
          }

          const ranked = this.products
            .map((product) => this.score(product))
            .sort((a, b) => b.score - a.score || b.priority - a.priority || a.product.title.localeCompare(b.product.title))
            .slice(0, 3);

          this.status.textContent = '';
          this.resultGrid.innerHTML = ranked.map((result, index) => this.card(result, index)).join('');
          this.results.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } catch (error) {
          this.status.textContent = this.root.dataset.errorText;
        }
      }

      card(result, index) {
        const product = result.product;
        const vocabulary = JSON.parse(this.root.querySelector('[data-ap-discovery-labels]').textContent);
        const image = product.image
          ? `<img src="${escapeHtml(product.image)}" alt="${escapeHtml(product.title)}" loading="lazy" width="900" height="675">`
          : '';
        const chips = result.matches
          .map((match) => `<span class="ap-scent-finder__match">${escapeHtml(match)}</span>`)
          .join('');

        return `
          <article class="ap-scent-finder__result">
            <a class="ap-scent-finder__result-media" href="${escapeHtml(product.url)}" tabindex="-1" aria-hidden="true">${image}</a>
            <div class="ap-scent-finder__result-content">
              <span class="ap-scent-finder__result-rank">0${index + 1} · ${escapeHtml(this.root.dataset.matchLabel)}</span>
              <span class="ap-scent-finder__result-family">${escapeHtml(vocabulary[product.family] || product.family)}</span>
              <h3 class="ap-scent-finder__result-title">${escapeHtml(product.title)}</h3>
              <span class="ap-scent-finder__result-price">${escapeHtml(product.price)}</span>
              <p class="ap-scent-finder__result-copy">${escapeHtml(product.resultCopy)}</p>
              <div class="ap-scent-finder__matches">${chips}</div>
              <a class="ap-scent-finder__result-link" href="${escapeHtml(product.url)}">
                ${escapeHtml(this.root.dataset.resultCta)} <span aria-hidden="true">→</span>
              </a>
            </div>
          </article>`;
      }

      restart() {
        this.answers = {};
        this.currentStep = 0;
        this.quiz.reset();
        this.results.hidden = true;
        this.quiz.hidden = false;
        this.steps.forEach((step, index) => {
          step.hidden = index !== 0;
          step.classList.remove('is-entering');
        });
        this.resultGrid.innerHTML = '';
        this.status.textContent = '';
        this.updateNavigation();
        this.quiz.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }

    const initialize = (scope = document) => {
      scope.querySelectorAll('[data-ap-scent-finder]').forEach((root) => new AromaticaScentFinder(root));
    };

    initialize();
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ap-weddings-events"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const focusSuccessfulForm = (root = document) => {
      const success = root.querySelector('[data-ap-events-form-success]');
      if (!success || success.dataset.apEventsFocused === 'true') return;

      success.dataset.apEventsFocused = 'true';
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      requestAnimationFrame(() => {
        success.focus({ preventScroll: true });
        success.scrollIntoView({
          behavior: reducedMotion ? 'auto' : 'smooth',
          block: 'center'
        });
      });
    };

    const initialize = () => focusSuccessfulForm();

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialize, { once: true });
    } else {
      initialize();
    }

    document.addEventListener('shopify:section:load', (event) => {
      focusSuccessfulForm(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-aromatica"] && !Shopify.designMode) return;
  try {
    
  if (!window.apContactValidationReady) {
    window.apContactValidationReady = true;
    const contactForm = (target) => target?.closest?.('[data-ap-contact] form');
    const validateField = (form, field) => {
      const error = form.querySelector(`#${field.id}Error`);
      const valid = field.checkValidity();
      field.setAttribute('aria-invalid', valid ? 'false' : 'true');
      if (error) error.hidden = valid;
      return valid;
    };
    const showFormErrors = (form) => {
      const fields = [...form.querySelectorAll('[data-contact-field]')];
      const invalid = fields.filter((field) => !validateField(form, field));
      if (!invalid.length) return false;
      const summary = form.querySelector('[data-contact-summary]');
      const errorList = form.querySelector('[data-contact-error-list]');
      errorList.replaceChildren(...invalid.map((field) => {
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = `#${field.id}`;
        link.textContent = form.querySelector(`label[for="${field.id}"]`)?.textContent.replace('*', '').trim() || field.name;
        item.append(link);
        return item;
      }));
      summary.hidden = false;
      if (invalid.length > 1) summary.focus();
      else invalid[0].focus();
      return true;
    };
    document.addEventListener('focusout', (event) => {
      const form = contactForm(event.target);
      if (form && event.target.matches('[data-contact-field]') && event.target.value.trim()) validateField(form, event.target);
    });
    document.addEventListener('input', (event) => {
      const form = contactForm(event.target);
      if (form && event.target.matches('[data-contact-field]') && event.target.getAttribute('aria-invalid') === 'true') validateField(form, event.target);
    });
    document.addEventListener('change', (event) => {
      const form = contactForm(event.target);
      if (form && event.target.matches('[data-contact-field]') && event.target.getAttribute('aria-invalid') === 'true') validateField(form, event.target);
    });
    document.addEventListener('click', (event) => {
      const link = event.target.closest('[data-contact-error-list] a[href^="#"]');
      if (link) {
        const field = document.querySelector(link.getAttribute('href'));
        if (field) field.focus();
        return;
      }
      let submit = event.target.closest('[data-ap-contact] button[type="submit"]');
      if (!submit && event.target.matches('[data-ap-contact] form') && document.activeElement?.matches('button[type="submit"]')) submit = document.activeElement;
      if (submit && showFormErrors(submit.form)) event.preventDefault();
    });
    document.addEventListener('submit', (event) => {
      const form = contactForm(event.target);
      if (!form) return;
      if (showFormErrors(form)) event.preventDefault();
    }, true);
  }
  document.querySelectorAll('[data-ap-contact] form').forEach((form) => {
    form.dataset.validationReady = 'true';
    const status = form.querySelector('[data-contact-status]');
    const summary = form.querySelector('[data-contact-summary]');
    if (status) status.focus();
    else if (summary && !summary.hidden) summary.focus();
  });

  } catch(e) { console.error(e); }
})();
})();
